<template>
    <v-container fluid>   
        <v-row class="mb-6 course-dashboard-list">
<!--                 <v-card v-for="(course,index) in courses" :key="course.id" class="ms-3 mb-6" min-width="25em" >                    
 -->            <v-col v-for="(course,index) in courses" :key="course.id" cols="12" sm="6" md="4" lg="3" xl="2" class="course-dashboard-list__item">                  
                    <v-card>                    

                      <v-card-title style="color:#fff;cursor:pointer" @click="showCourse(course)" primary-title class="layout justify-center course-dashboard-list__course-title" :style="getStyle(area_color)"><span>{{course.title}}</span></v-card-title>
                        <v-card-text @click="showCourse(course)">
                            <p>{{course.description}}</p>
                            <v-layout row wrap >                                 
                                <div class="flex xs6">
                                  <strong> Tasks: </strong> {{course.task_finished}} / {{course.task_all}}
                                </div>
                                <div class="flex xs6">
                                   <strong> Programs: </strong>{{course.program_finished}} / {{course.program_all}}
                                </div>
                                <v-flex v-if="isAdmin" xs12>
                                    {{course.content_all}}(C) + {{course.task_all}}(T) + {{course.program_all}}(P)
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions >
                            <div v-if="isAdmin">
                                    <v-icon @click="editCourse(course.id)">mdi-pencil</v-icon>
                                    <v-icon @click="edit2Course(course.id)" >preview</v-icon>
                                    <v-icon @click="deleteCourse(course.id)" >mdi-delete</v-icon>
                                    <v-icon v-if="index > 0" @click="moveCourse(index, index-1)">mdi-arrow-left</v-icon>
                                    <v-icon v-if="index < courses.length-1" @click="moveCourse(index, index+1)">mdi-arrow-right</v-icon>
                            </div>
                            <div v-if="!isAdmin">
                                Status: 
                                <span v-if="course.course_status == null" style="color:green" ><strong>new</strong></span>
                                <span v-if="course.course_status != null">{{course.course_status}}</span>
                            </div>
                        </v-card-actions> 
                        
                    </v-card>
                    </v-col>
      
       
                <v-card v-if="$store.getters.isAdmin" class="mb-6 mx-auto">                    
                    <v-card-text>
                        <v-layout justify-center>
                            <v-icon size="x-large" @click="addCourse()">mdi-plus-circle-outline</v-icon> 
                        </v-layout>
                    </v-card-text>  
                </v-card>
        </v-row>
    </v-container>    
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            courses : [],
            area_color : "#000000",
            isAdmin: false,
            area_id: 0,
            category_id: 0
            
        }
    },
    mounted() {
        this.initData()
    },
    methods :{
        initData() {
            /* eslint-disable no-console */
            // console.log('courses redraw')
            this.$store.commit('setFeedback', null)
            this.isAdmin = this.$store.getters.isAdmin
            var address = '/area-all-courses/' + this.$route.params.id
            if (this.isAdmin) {
                address = '/area-all-courses2/' + this.$route.params.id
            } 

            axios.get(address, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                this.courses = res.data.list 
                this.area_id = res.data.area.id
                this.area_color = res.data.area.area_color
                const bc = [
                    { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                    { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#             
                ]
                this.$store.commit('setBreadCrumbs',bc)   
                this.category_id = res.data.category.id
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })            
            
        },
        getTargetLink(course) {
            if (this.isAdmin) return 'course_admin_content'
            // not admin
            if (course.course_status == null) return 'course_preview'
            return 'course_content'
        },
        addCourse() {
            this.$router.push({name:'admin_course', params: {category_id: this.category_id, area_id: this.area_id, id: '0'}})
        },
        editCourse(id) {
            this.$router.push({name:'admin_course', params: {category_id: this.category_id, area_id: this.area_id, id: id}})
        },
        edit2Course(id) { 
            this.$router.push({name:'edit_chapters', params: {id: id}})
        },
        deleteCourse(id) {
            this.$store.commit('setFeedback', null)    
            // get list
            axios.get('/delete-course/' + id, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })        
        },
        moveCourse(p1, p2) {
            const data = {
                course_id1: this.courses[p1].id,
                course_order1: this.courses[p1].course_order,
                course_id2: this.courses[p2].id,
                course_order2: this.courses[p2].course_order
            }
            axios.post('/course-change-order', data, this.$store.getters.getAxiosConfig )
            .then(() => {
            // set data to var
                this.initData()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
      },
      showCourse(course) {
          this.$router.push({name:this.getTargetLink(course), params: {id: course.id}})          
      },
      getStyle(col) {
          return "color: white; background-color: "+col+"; margin-bottom: 0.5em;";
      }



    }
}
</script>

<style>
</style>